<section class="page-container">
  <div class="flex items-center justify-between">
    <h1 class="main-heading">Download Documents</h1>
    <app-navpath class="hidden md:block" />
  </div>
  <button class="shorter-btn add-btn" (click)="openUpload(true)">
    <fa-icon [icon]="faUpload" class="mr-1"></fa-icon>Upload Files
  </button>
  <div class="content-container" *ngFor="let group of groupList">
    <h2 class="sub-heading w-full border-b">{{ group }}</h2>
    <app-data-table
      [tableHeaders]="tableHeaders"
      [tableEntries]="handleGroup(group)"
      [pagination]="false"
      (remove)="openDelete($event, group)"
      (download)="downloadFile($event, group)"
    ></app-data-table>
  </div>
</section>
<div class="bg-modal" *ngIf="showUpload">
  <div class="container-upload">
    <h2 class="sub-heading w-full border-b">Manage Documents</h2>
    <app-data-form [dataFields]="documentsForm" />
    <label class="block px-8 text-sm font-bold">
      Select file
      <input
        type="file"
        name=""
        id=""
        (change)="onFileChange($event)"
        class="ml-16"
      />
    </label>
    <div class="flex w-full justify-end gap-2 border-t pt-4">
      <button class="shorter-btn add-btn" (click)="uploadFile()">
        <fa-icon [icon]="faUpload" class="mr-1"></fa-icon>Upload
      </button>
      <button
        class="shorter-btn clear-btn"
        (click)="openUpload(false)"
      >
        <fa-icon [icon]="faCancel" class="mr-1"></fa-icon>Cancel
      </button>
    </div>
  </div>
</div>
